import { createConfirmation } from "react-confirm";
import AddPriceTierDialog from "./AddPriceTierDialog";

export const showAddPriceTierDialog = createConfirmation(AddPriceTierDialog);
